module.exports = __webpack_public_path__ + "img/iolite.8c0c3acd.svg";